module.exports = __webpack_public_path__ + "img/it_iron_2019_agile_badge.0726164b.png";